import { render, staticRenderFns } from "./AdminHome.vue?vue&type=template&id=621d01f9&scoped=true&"
import script from "./AdminHome.vue?vue&type=script&lang=js&"
export * from "./AdminHome.vue?vue&type=script&lang=js&"
import style0 from "./AdminHome.vue?vue&type=style&index=0&id=621d01f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621d01f9",
  null
  
)

export default component.exports